var bubbletext;
var prev_pin;
var map = Array();
var icon;
var marker;
var markers = Array();
var latlng;
var baseIcon;
var markerOptions;
var geocoder;
var infowindow;

function setMarkers(map, markers, regionmap) {
    var marker_list = [];
    var bounds = new google.maps.LatLngBounds();

    for (var i = 0; i < markers.length; i++) {
        var sites = markers[i];
        var siteLatLng = new google.maps.LatLng(sites[1], sites[2]);
        var marker = new google.maps.Marker({
            position: siteLatLng,
            map: map,
            animation: google.maps.Animation.DROP,
            title: sites[0],
            zIndex: sites[4],
            html: sites[3]
        });

        marker_list.push(marker);

        bounds.extend(siteLatLng);

        google.maps.event.addListener(marker, "click", function () {
            infowindow.setContent(this.html);
            infowindow.open(map, this);
        });
    }

    var markerCluster = new MarkerClusterer(map, marker_list, {
        gridSize: 40,
        minimumClusterSize: 2,
        zoomOnClick: true,
        calculator: function (markers, numStyles) {
            // Custom style can be returned here
            return {
                text: markers.length,
                index: numStyles
            };
        }
    });

    if (markers.length > 1) {
        map.fitBounds(bounds);
        map.panToBounds(bounds);
    } else {
        map.setCenter(bounds.getCenter());
        map.setZoom(12);
    }

    if (regionmap == 0) {
        infowindow.setContent(marker_list[0].html);
        infowindow.open(map, marker_list[0]);
    }
}

var locationsetupInner = function (centerlat, centerlng, gzoom, regionmap, dragmarker, geo, geosearch) {
    var myOptions = {
        center: new google.maps.LatLng(centerlat, centerlng),
        zoom: gzoom,
        mapTypeId: 'roadmap'
    }

    map = new google.maps.Map(document.getElementById("map"), myOptions);

    infowindow = new google.maps.InfoWindow({
        content: "loading..."
    });

    if (geo == 1) {
        geocoder = new google.maps.Geocoder();

        geocoder.geocode({
            'address': geosearch
        }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var markerpos = results[0].geometry.location;

                map.setCenter(markerpos);

                var marker = new google.maps.Marker({
                    map: map,
                    position: markerpos
                });

                google.maps.event.addListener(marker, "click", function () {
                    infowindow.setContent(bubbletext);
                    infowindow.open(map, this);
                });

                infowindow.setContent(bubbletext);
                infowindow.open(map, marker);
            }
        });

    } else if (dragmarker) {
        lat = $('#lat');
        lng = $('#lng');

        if (lat.val() != '') {
            var markerpos = new google.maps.LatLng(lat.val(), lng.val());

            pin = new google.maps.Marker({
                position: markerpos,
                map: map,
                draggable: true
            });

            prev_pin = pin;

            google.maps.event.addListener(pin, "dragend", function () {
                var point = this.getPosition();
                map.panTo(point);

                $('#lat').val(point.lat());
                $('#lng').val(point.lng());
            });
        }

        google.maps.event.addListener(map, "click", function (event) {
            if (prev_pin) {
                prev_pin.setMap(null);
                prev_pin = null;
            }

            if (event) {
                pin = new google.maps.Marker({
                    position: event.latLng,
                    map: map,
                    draggable: true
                });

                prev_pin = pin;

                map.panTo(event.latLng);

                google.maps.event.addListener(pin, "dragend", function () {
                    var point = this.getPosition();
                    map.panTo(point);

                    $('#lat').val(point.lat());
                    $('#lng').val(point.lng());
                });

                $('#lat').val(event.latLng.lat());
                $('#lng').val(event.latLng.lng());
            }
        });
    } else {
        setMarkers(map, markers, regionmap);
    }
}

var locationsetup = function (centerlat, centerlng, gzoom, regionmap, dragmarker, geo, geosearch) {
    if (googleMapsAPILoaded) {
        new locationsetupInner(centerlat, centerlng, gzoom, regionmap, dragmarker, geo, geosearch);
    } else {
        $.getScript("https://maps.google.com/maps/api/js?key=" + googleMapsAPIKey)
            .done(function (script, textStatus) {
                new locationsetupInner(centerlat, centerlng, gzoom, regionmap, dragmarker, geo, geosearch);
            });
    }
}

var drivingdirectionsInner = function (centerlat, centerlng, gzoom, start, end) {
    directionsDisplay = new google.maps.DirectionsRenderer();

    var myOptions = {
        center: new google.maps.LatLng(centerlat, centerlng),
        zoom: gzoom,
        mapTypeId: 'roadmap'
    }

    map = new google.maps.Map(document.getElementById("map"), myOptions);

    directionsDisplay.setMap(map);
    directionsDisplay.setPanel(document.getElementById('route'));

    var directionsService = new google.maps.DirectionsService();

    var request = {
        origin: start,
        destination: end,
        travelMode: google.maps.TravelMode.DRIVING
    };

    directionsService.route(request, function (response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
        }
    });
}

var drivingdirections = function (centerlat, centerlng, gzoom, start, end) {
    if (googleMapsAPILoaded) {
        new drivingdirectionsInner(centerlat, centerlng, gzoom, start, end);
    } else {
        $.ajaxSetup({
            cache: true
        });
        $.getScript("https://maps.google.com/maps/api/js?key=" + googleMapsAPIKey)
            .done(function (script, textStatus) {
                new drivingdirectionsInner(centerlat, centerlng, gzoom, start, end);
            });
    }
};
